import React, { useState, useEffect, forwardRef } from 'react';
import Grid from '@material-ui/core/Grid'
import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import axios from 'axios'
import Alert from '@material-ui/lab/Alert';
import DataForm from './DataForm';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { useSelector, useDispatch } from "react-redux";

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const api = axios.create({
    baseURL: 'MasterDetails'
})

const apiSlip = axios.create({
    baseURL: 'SlipGeneration'
})

function DataTable(props) {
    const [data, setData] = useState([]);

    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);
    
    function getSlipGenDetails() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let SlipGenId = Number(props.SlipGenId);
        apiSlip.get("/getTrnSlipGenDetails/" + SlipGenId,{
            headers: headers
        })
            .then(res => {
                setData(res.data)
            })
            .catch(error => {
                console.log("Error in hitting api at page load. : SlipGenDetails")
            })
    }

    function getDataFromDataForm(data) {
        //console.log(data);
        setData(data);
        props.getHeaderCalculation(data);
    }

    //table data 
    var columns = [
        { title: 'Wage Group', field: 'wageGroup' },
        { title: 'Work CTR', field: 'workCenterCode' },
        { title: 'Material', field: 'materialCode' },
        { title: "GrC", field: "grcCode" },
        { title: "Operations", field: "operation" },
        { title: "OK Pcs", field: "noOfOkpiece" },
        { title: "NOK Pcs", field: "noOfNotOkpiece" },
        { title: "No Of Settings", field: "noOfSettings" },
        { title: "Add Setup Time", field: "addSetUpTime" },
        { title: "Extra Cost", field: "extraCost" },
        { title: "Input Min", field: "inputMin" },
        { title: 'Working Method', field: 'workingMethodName' },
        { title: "Output Mins", field: "outputMins" },
    ]

    //for error handling
    const [iserror, setIserror] = useState(false)
    const [errorMessages, setErrorMessages] = useState([])
    
    useEffect(() => {
        getSlipGenDetails();
    }, [])

    const handleRowDelete = (oldData, resolve) => {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
          apiSlip.delete("/DeleteSlipDetails/" + oldData.id,{
            headers: headers
        })
            .then(res => {
                const dataDelete = [...data];
                const index = oldData.tableData.id;
                dataDelete.splice(index, 1);
                setData([...dataDelete]);
                resolve()
            })
            .catch(error => {
                setErrorMessages(["Delete failed! Server error"])
                setIserror(true)
                resolve()
            })
    }

    const [isDialogOpen, setisDialogOpen] = useState(false);
    const [editslipDetailsData, seteditslipDetailsData] = useState('');

    function editSlipData(rowData) {
        //console.log(rowData);
        setisDialogOpen(true);
        seteditslipDetailsData(rowData);
    }

    const goBackonClick = () => {
        //alert(0);
        setisDialogOpen(false);
        seteditslipDetailsData('');
    }

    return (
        <div className="width-100">
            <Grid container spacing={1}>
                {
                    props.SlipGenId > 0 ?
                    (
                        <Grid item xs={12} sm={12} className="d-flex Width-100 jc-flex-end">
                                <DataForm getDataOnSubmit={getDataFromDataForm.bind(this)} SlipGenId={props.SlipGenId} SlipGenDetId={0}
                                    MrpcontrollerId={props.MrpcontrollerId} isDisabled={props.isDisabled}
                                    isDialogOpen={isDialogOpen} editData={editslipDetailsData} clickgoback={goBackonClick} loginuser={props.loginuser} />
                        </Grid>
                    ) : <React.Fragment></React.Fragment>
                }
                {
                    data.length > 0 ?
                        (
                            <Grid item xs={12}>
                                <div>
                                    {iserror &&
                                        <Alert severity="error">
                                            {errorMessages.map((msg, i) => {
                                                return <div key={i}>{msg}</div>
                                            })}
                                        </Alert>
                                    }
                                </div>
                                <MaterialTable
                                    title=""
                                    columns={columns}
                                    data={data}
                                    icons={tableIcons}
                                    options={{
                                        search: false,
                                        paging: false,
                                        showTitle: false,
                                        toolbar: false,
                                    }}
                                    detailPanel={rowData => {
                                        return (
                                            <div className="p-1 ml-1 detail-dashboard">                                                
                                                <div>Work Center : {rowData.workCenterName} </div>
                                                <div>Material : {rowData.material} </div>
                                                <div>Group Center : {rowData.grcDescription} </div>
                                                <div>Operations : {rowData.operationNameValue} </div>
                                            </div>
                                        );
                                    }}
                                    actions={[
                                        rowData => ({
                                            icon: () => <EditOutlinedIcon fontSize="small" />,
                                            tooltip: 'Edit',
                                            onClick: () => editSlipData(rowData)
                                        })
                                    ]}
                                    editable={{                                        
                                        onRowDelete: (oldData) =>
                                            new Promise((resolve) => {
                                                handleRowDelete(oldData, resolve)
                                            }),
                                    }}
                                />
                            </Grid>
                        ) : <React.Fragment></React.Fragment>
                }
            </Grid>
        </div>
    );
}

export default DataTable;